import React from 'react';
import { stats } from '../data/content';
export function StatsBar() {
  return <section className="w-full bg-ink py-16 text-white sm:py-20" data-id="element-240" data-mp="1tai2pb8gatrc">
      <div className="mx-auto max-w-6xl px-5" data-id="element-241" data-mp="1tb9nrs4f993d">
        <h2 className="mx-auto max-w-3xl text-center font-display text-2xl font-black leading-tight tracking-tight sm:text-4xl" data-id="element-242" data-mp="1oavqn54czjk4">
          Less Preparation. More Teaching.{' '}
          <span className="text-sun" data-id="element-243" data-mp="1ed7j1elnmhkj">Everything in One Place.</span>
        </h2>
        <dl className="mt-12 grid grid-cols-2 gap-y-10 md:grid-cols-4 md:gap-y-0" data-id="element-244" data-mp="1efbwoo9cuuy0">
          {stats.map((stat, index) => <div key={stat.label} className={`px-4 text-center ${index > 0 ? 'md:border-l md:border-white/15' : ''}`} data-id="element-245" data-mp="19ko5uiqvpog9" data-mpi={index}>
              <dt className="sr-only" data-id="element-246" data-mp="10m2sd209kzmc">{stat.label}</dt>
              <dd data-id="element-247" data-mp="10nnnasqhqkkq">
                <span className="block font-display text-5xl font-black leading-none text-sun sm:text-7xl" data-id="element-248" data-mp="10jztdsh4vw5h">
                  {stat.value}
                </span>
                <span className="mt-3 block text-[11px] font-bold uppercase tracking-[0.14em] text-white/75 sm:text-xs" data-id="element-249" data-mp="qoy1wpzdyhzq">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
        <p className="mx-auto mt-12 max-w-2xl text-center text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-250" data-mp="3tgx20y2wcwsx">
          One organized system to help students explore their options, practice
          workplace skills, and connect classroom learning with life beyond
          school.
        </p>
      </div>
    </section>;
}